import * as React from "react";
import { IChangableImageProps } from "./~types/ChangableImageProps";
import { IChangableImageState } from "./~types/ChangableImageState";
import Avatar from "react-avatar-edit";
import * as material from "@mui/material";
import ContactIcon from "@mui/icons-material/AccountCircle";
import { ModalWindow } from "src/app/shared/components/modal-window/ModalWindow";
import i18n from "src/app/shared/localization/i18n";
import { FILE_MAX_SIZE } from "src/~store/constants";

import "./ChangableImage.css";
import { showErrorToastr } from "../../helpers/toastr-helper/ToastrHelper";
import { AVATAR_FORMATS } from "./ChangableImageConstants";

export default class ChangableImage extends React.Component<
  IChangableImageProps,
  IChangableImageState
> {
  public readonly state: IChangableImageState = {
      filePicker: React.createRef<HTMLInputElement>(),
      imageSrc: this.props.src,
      isOpen: false,
      setPreview: ""
  };

    public render() {
     const fallbackIconColor = this.props.fallbackIconColor ?? "#26a69a";

    return (    
      <React.Fragment>
        <material.Avatar
                className={this.props.className}
                src={this.props.src}
                onClick={() => {
                    if (this.props.isActive) {
                        this.setState({ isOpen: true });
                    }
                }}
            >
          <ContactIcon style={{ color: fallbackIconColor }} />
            </material.Avatar>
            {this.state.isOpen && (
                <div>
                    {this.CreateAvatar()}
                </div>
            )}
      </React.Fragment>
    );
    }

    private dataURLtoFile(dataurl: any, filename: any) {

        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
    }

    private CreateAvatar = () => {

        const onCrop = (defaultPreview: any) => {

            this.setState({ setPreview: defaultPreview });
        };

        const onClose = () => {
            this.setState({ setPreview: "" });
        };

        const onBeforeFileLoad = () => { };

        const onFileLoad = (data: React.ChangeEvent<HTMLInputElement> | File) => {
            if (!AVATAR_FORMATS.includes(data.type)) {
                showErrorToastr(i18n.t("contact.unsupportedAvatarImageType"));
                throw new Error("Unsupported avatar file type");
            }
            if (data.size > FILE_MAX_SIZE) {
                showErrorToastr(i18n.t("operators.setAvatarError"));
                throw new Error("Avatar image file size too large");
            }
        }

        const onSelectPic = () => {
            var file = this.dataURLtoFile(this.state.setPreview, 'hello.png');
            this.props.onImageChange?.(file);
            this.setState({ isOpen: false })
            this.setState({ setPreview: "" })
        };

        const onCancelSelect = () => {
            this.setState({ setPreview: "" })
            this.setState({ isOpen: false });
        };

        const header = () => {
            return (
                <>
                    <div className="avatar-header__close-button-wrapper">
                        <button
                            type="button"
                    className="avatar-header__close-button  red btn btn-secondary"
                            onClick={onCancelSelect}
                        >
                        <i className="material-icons">
                            close
                        </i>
                    </button></div></>)
        }

        const body = () => {
            return (
                <div>
                    <div>
                        <div className="avatar-body__file-choose">
                            <Avatar
                                label={i18n.t("contact.chooseFile")}
                                mimeTypes={AVATAR_FORMATS.join(',')}
                                width={270}
                                height={180}
                                onCrop={onCrop}
                                onClose={onClose}
                                onBeforeFileLoad={onBeforeFileLoad}
                                onFileLoad={onFileLoad}
                            />
                        </div>
                    </div>
                    <div>
                        <div className="avatar-body__image-preview">
                            {this.state.setPreview && (
                                <img
                                    alt="preview"
                                    src={this.state.setPreview}
                                    width="75%"
                                    height="75%"
                                    className="rounded-circle"
                                />
                            )}
                        </div>
                    </div>
                </div>)
        }

        const footer = () => {
            return (
                    <div>
                        <button
                            type="button"
                            className="btn btn-success btn-md float-right mr-2 mb-3 text-center"
                            onClick={onSelectPic}
                            disabled={!this.state.setPreview}
                            style={{ minWidth: "100px" }}
                        >
                        {i18n.t('common.save')}
                        </button>
                    </div>)
        }

        return (
            <ModalWindow
                isOpen={this.state.isOpen}
                header={header()}
                body={body()}
                footer={footer()}
                className="avatar-editor-window"
            />
        );
    };
}
